export default __webpack_public_path__ + "static/media/admin_icon.b78b6fe1.png";